import { render, staticRenderFns } from "./SettingsUserListing.vue?vue&type=template&id=5563568e&scoped=true&"
import script from "./SettingsUserListing.vue?vue&type=script&lang=js&"
export * from "./SettingsUserListing.vue?vue&type=script&lang=js&"
import style0 from "./SettingsUserListing.vue?vue&type=style&index=0&id=5563568e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5563568e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VOverlay,VProgressCircular,VSpacer,VSystemBar})
